import 'angular';

export default () => {
    return {
        AccountSearchCriteria: {
            contactName: '',
            city: '',
            state: '',
            postalCode: ''
        }
    };
};